module.exports = __webpack_public_path__ + "img/workflow-1.c0f13071.png";